var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.187,
    height: 84.273,
    viewBox: "0 0 73.187 84.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trust-wallet-token-twt-seeklogo",
    transform: "translate(-29.008 -23.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M513.1,369.641a4.286,4.286,0,0,1,4.28,4.341c-.205,12.266-.679,21.648-1.564,29.075-.862,7.427-2.16,12.944-4.115,17.408a27.668,27.668,0,0,1-4.852,7.552,37.787,37.787,0,0,1-8.724,6.709c-1.372.82-2.8,1.631-4.293,2.481-3.193,1.813-6.7,3.807-10.686,6.472a4.257,4.257,0,0,1-4.752,0c-4.043-2.694-7.6-4.714-10.818-6.538q-1.074-.609-2.1-1.2a45.69,45.69,0,0,1-10.12-7.262,25.9,25.9,0,0,1-5.043-7.242,50.637,50.637,0,0,1-4.029-14.445c-1.246-8.012-1.859-18.487-2.089-33.011a4.288,4.288,0,0,1,1.215-3.062,4.362,4.362,0,0,1,3.065-1.276h1.77c5.451.02,17.487-.514,27.9-8.618a4.294,4.294,0,0,1,5.247,0c10.409,8.1,22.445,8.645,27.923,8.618m-7.776,48.083a42.758,42.758,0,0,0,3.292-12.036c1.008-6.544,1.626-15.433,1.916-27.528-6.419-.186-17.448-1.42-27.962-8.5-10.514,7.057-21.542,8.288-27.942,8.5.227,10,.679,17.777,1.4,23.887.823,6.953,1.995,11.667,3.457,14.979A18.382,18.382,0,0,0,461,422.216a29.539,29.539,0,0,0,6.808,5.188c1.221.731,2.568,1.494,4.029,2.324,2.61,1.477,5.6,3.167,8.928,5.287,3.273-2.087,6.215-3.759,8.8-5.228.778-.442,1.521-.862,2.231-1.275a38.533,38.533,0,0,0,8.289-5.82,18.112,18.112,0,0,0,3.447-4.966",
    transform: "translate(-415.184 -336.42)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustWallet);
export default __webpack_public_path__ + "static/media/trust_wallet.9ce5c61370bea557396b52da591671d6.svg";
export { ForwardRef as ReactComponent };